<template>
  <v-card elevation="5">
    <title-card :text="`Datos Históricos ${axis ? 'en ' + axis.nombre_corto: ''}`"/>
    <v-row justify="center">
      <v-col 
        v-for="(period, idx) in real_valid_periods"
        class="mt-1 pb-0"
        :cols="Math.round(12 / real_valid_periods.length)"
      >
        <v-row >
          <v-col cols="12" align="center">
            <v-badge
              _color="axis ? axis.color : color_idx"
              color="transparent"
              left
              overlap
              offset-y="-10"
              offset-x="50"
            >
              <template v-slot:badge>
                <b
                  class="title" 
                  :style="`color: ${axis ? axis.color : color_idx};`"
                >
                  {{format_perc(period_mean(period))}}
                </b>
              </template>
              <BubbleChart 
                :ies="ies"
                :col="{id: idx, color: axis ? axis.color : color_idx,
                  nombre_corto: '-----'}"
                :value="period_mean(period)"
                :mean="'examp'"
                _axis="{id: idx, color: axis ? axis.color : color_idx,
                  nombre_corto: '-----'}"
                :axis="axis"
                :period="period"
              />
            </v-badge>
          </v-col>
          <v-col cols="12" align="center" class="pt-0">
            {{period.year}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>


<script>

import { mapState, } from "vuex";
//import * as d3 from 'd3';
import homeMixin  from "../homeMixin";
import BubbleChart from "../charts/BubbleChart";
import TitleCard from "../common/TitleCard";

export default {
  name: 'HistoricData',
  components: {
    BubbleChart,
    TitleCard,
  },
  mixins: [homeMixin],
  props:{
    axis:{
      type: Object,
      required: false,
    },
    ies:{
      type: Object,
      required: false,
    },
    periods_ies:{
      type: Array,
      required: false,      
    }
  },
  data(){
    return {
      period_2017: [{"id":1,"year":2017,"data_details":"Publicada el 04/04/2019","equality_index": 1.540625,"stage":"final"}],
      period_zero: [{"id":1,"year":2017,"data_details":"Publicada el 04/04/2019","equality_index": 0 ,"stage":"final"}],
        //,{"id":2,"year":2018,"data_details":"Publicada el 04/04/2019","equality_index":1.73,"stage":"final"}],
    }
  },
  computed:{
    ...mapState({
      valid_periods: state => state.valid_periods,
      current_period_axis: state => state.current_period_axis,
    }),
    real_valid_periods(){
      if (this.periods_ies)
        return this.periods_ies || this.period_zero
      else if (this.axis)
        return this.current_period_axis || this.period_zero
      else
        return this.valid_periods || this.period_2017
    },
  },  
  methods: {
    period_mean(period){
      return period.equality_index || period.mean_value || 0
    }
  },
  mounted(){
    
  },
}
</script>

<style lang="scss" scoped>
</style>